import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Container, Typography, Anchor, List, Grid, Spinner } from 'components/base';
import Icon, { ICON_TYPE } from 'components/icon';

import { UserPageLink } from '../pageLinks';

export const PROJECT_SECTION = {
  CREATIONS: 'creations',
  TREES: 'trees',
  ANCESTRY: 'ancestry',
  FAMILYSEARCH: 'familysearch',
};

const PROJECT_SECTION_LABEL = {
  [PROJECT_SECTION.CREATIONS]: 'My Creations',
  [PROJECT_SECTION.TREES]: 'My Family Trees',
  [PROJECT_SECTION.ANCESTRY]: 'Ancestry Family Trees',
  [PROJECT_SECTION.FAMILYSEARCH]: 'FamilySearch Trees',
};

const UserProjectsContainer = props => (
  <Container>
    <Typography.H2 className="section-title mb-2">MY PROJECTS</Typography.H2>

    <Grid.Row>
      <Grid.Col xs={8}>
        <List className="navbar-nav full">
          {Object.values(PROJECT_SECTION).map(key => {
            const className = classNames({
              'nav-link': true,
              'nav-link-active': props.section === key,
            });

            let children = (<UserPageLink section={key}>
              <Anchor className={className}>{PROJECT_SECTION_LABEL[key]}</Anchor>
            </UserPageLink>);

            if (key === PROJECT_SECTION.ANCESTRY) {
              children = <Anchor
                href="https://www.ancestry.com/family-tree/tree"
                targetBlank
                className={className}
              >
                <Icon type={ICON_TYPE.ANCESTRY} className="text-ancestry" />{' '}
                {PROJECT_SECTION_LABEL[key]}
              </Anchor>
            } else if (key === PROJECT_SECTION.FAMILYSEARCH) {
              children = <Anchor
                href="https://www.familysearch.org/en/tree/pedigree/"
                targetBlank
                className={className}
              >
                <Icon type={ICON_TYPE.FAMILY_SEARCH} className="text-familysearch" />{' '}
                {PROJECT_SECTION_LABEL[key]}
              </Anchor>
            }

            return (
              <List.Item key={key} className="nav-item">
                {children}
              </List.Item>
            );
          })}
        </List>
      </Grid.Col>
      <Grid.Col xs={4} className="d-flex align-items-center justify-content-end">
        {props.action}
      </Grid.Col>
    </Grid.Row>

    {props.children}

    {props.loading && (
      <Grid.Row className="justify-content-center align-items-center minh-150 w-100">
        <Spinner />
      </Grid.Row>
    )}
  </Container>
);

UserProjectsContainer.propTypes = {
  section: PropTypes.string,
  loading: PropTypes.bool,
  action: PropTypes.node,
  children: PropTypes.node,
};

export default UserProjectsContainer;
